<script setup lang="ts">
import UserBadge from '@/components/Profile/UserBadge.vue';
import type { Employee } from '@/types/api';
import type { KitchenPosition } from '@/types/employee';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const props = defineProps<{
  positions: Array<{
    position: KitchenPosition;
    users: Employee[];
  }>;
  title?: string;
  noUsersText?: string;
}>();

const positionsWithUsers = computed(() => {
  return props.positions.filter(({ users }) => users.length > 0);
});
</script>

<template>
  <div v-if="positionsWithUsers.length > 0">
    <p v-if="title" class="mb-2 font-bold">{{ title }}</p>
    <div class="flex flex-wrap gap-8">
      <div v-for="{ position, users } in positionsWithUsers" :key="position.id" class="min-w-[180px]">
        <div class="mb-2 flex items-center gap-2">
          <span v-if="position.color" class="inline-block h-4 w-4 rounded-full" :style="{ backgroundColor: '#' + position.color }"></span>
          <span class="font-semibold">{{ t(`employee.kitchenPositions.positions.${position.name}`) }}</span>
        </div>
        <div class="flex flex-col flex-wrap gap-2">
          <div v-for="user in users" :key="user.id" class="flex flex-row gap-3">
            <UserBadge :user="user" :color="position.color" show-name />
          </div>
          <span v-if="users.length === 0" class="text-xs text-gray-400">
            {{ noUsersText || 'No users assigned' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
